
module.exports.maximumNoOfDockBarButtons = 5;
module.exports.dockBarDroppableId = "dockBarButtonDroppables"

module.exports.maximumNoOfPageBarButtons = 4;
module.exports.pageBarDroppableId = "pageBarButtonDroppables"